import Instance from "../../../../Axios";

// New Actions for the app

const GetCredenciacaoById = (id) => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/cred/${id}`)
    .then(({ data }) => {
      dispatch({ type: "GET_CREDENCIACAO_BY_ID", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredenciacaoById;